export enum NameSpace {
  UserData = 'UserData',
  Tariff = 'Tariff',
  Task = 'Task',
  Cart = 'Cart',
}
